import * as Sentry from "@sentry/tanstackstart-react";
import { createRouter as createTanstackRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";

import { DefaultErrorContent } from "@/components/error";

import "./styles.css";
import { NotFoundContent } from "@/components/not-found";
import { getContext } from "@/integrations/tanstack-query/root-provider";

import { routeTree } from "./routeTree.gen";

declare const __APP_VERSION__: string;

export function getRouter() {
  const rqContext = getContext();

  const router = createTanstackRouter({
    scrollRestoration: true,
    scrollToTopSelectors: ["#scroll-ref"],
    routeTree,
    context: {
      ...rqContext,
    },
    defaultPreload: "intent",
    defaultNotFoundComponent: NotFoundContent,
    defaultErrorComponent: DefaultErrorContent,
  });

  setupRouterSsrQueryIntegration({
    router,
    queryClient: rqContext.queryClient,
    wrapQueryClient: false,
  });

  if (!router.isServer) {
    Sentry.init({
      dsn: "https://ee2bb2e4c972c2017c044aede931cef4@o442286.ingest.us.sentry.io/4510468109959168",
      enabled: import.meta.env.PROD,
      environment: import.meta.env.MODE,
      release: __APP_VERSION__,
      sendDefaultPii: true,
      integrations: [
        Sentry.tanstackRouterBrowserTracingIntegration(router),
        Sentry.replayIntegration({
          maskAllText: false,
        }),
      ],
      tracesSampleRate: 0.2,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  return router;
}
